import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SewPicture, SewWsQuote } from '@sew/ui-components-angular/standalone';
import { Content } from '../../../../models/blog-posts.model';

@Component({
    selector: 'blog-cite',
    templateUrl: './cite.component.html',
    styleUrls: ['./cite.component.scss'],
    imports: [CommonModule, SewWsQuote, SewPicture],
})
export class CiteComponent implements OnInit {
    @Input() public cite?: Content;

    public ngOnInit(): void {
        if (this.cite && this.cite.date && this.cite.date.length) {
            const date = new Date(this.cite.date);
            this.cite.date =
                date.getDate() +
                '. ' +
                date.toLocaleString('default', { month: 'long' }) +
                ' ' +
                date.getFullYear();
        }
    }
}
